import "./ResultPanel.css";
import PatientTable from "../patientTable/PatientTable";
import PatientTableHeader from "../patientTable/PatientTableHeader";
import useTranslation from "../../../../hooks/i18n/useTranslation";
import { usePatientListDataFilter } from "../../../../hooks/queries/usePatientListDataFilter";

function ResultPanel({ searchCriteria = {} }) {
  const { t } = useTranslation();

  const {
    loading,
    resultsPatientFiltering,
    refreshPatients,
    sortColumn,
    sortDirection,
    handleSort,
  } = usePatientListDataFilter(searchCriteria);

  return (
    <div className="App-module-patients-database">
      <label className="App-module-patients-label">{t("182")}</label>
      <PatientTableHeader
        sortColumn={sortColumn}
        sortDirection={sortDirection}
        handleSort={handleSort}
      />
      <div className="App-module-patients-result">
        <div className="App-module-patients-table-wrapper">
          <PatientTable
            loading={loading}
            resultsPatientFiltering={resultsPatientFiltering}
            refreshPatients={refreshPatients}
          />
        </div>
      </div>
    </div>
  );
}

export default ResultPanel;
